module.exports = __webpack_public_path__ + "static/media/BMMI_Shops_Logo.c3a3c17c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BMMI_Shops_Logo.svg
// module id = 266
// module chunks = 0